/*
 * File: /src/services/leadService.js
 * Created Date: Thursday November 4th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 28th November 2021 11:32:18 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_LEAD_PATH } from '../constants';

export default {
  /**
   * Fetch All Leads
   *
   * @returns
   */
  fetchByCompanyId(params) {
    return authedAxios.get(AD_BASE_LEAD_PATH, { params: params });
  },

  // Find most resent open lead if any
  findOpenByContact(contactId) {
    return authedAxios.get(AD_BASE_LEAD_PATH + 'open/' + contactId);
  },

  fetchById(id) {
    return authedAxios.get(AD_BASE_LEAD_PATH + id, {});
  },

  updateLead(id, payload) {
    return authedAxios.put(AD_BASE_LEAD_PATH + id, payload);
  },

  createLead(payload) {
    return authedAxios.post(AD_BASE_LEAD_PATH, payload);
  },
  archiveLead(id) {
    return authedAxios.put(AD_BASE_LEAD_PATH + 'archive/' + id);
  },
  unarchiveLead(id) {
    return authedAxios.put(AD_BASE_LEAD_PATH + 'unarchive/' + id);
  }
};
